export default "__VITE_ASSET__DpCNFsEU__"